<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p><strong>Display Name:</strong> {{ vehicle.displayName }}</p>
        <p><strong>VIN:</strong> {{ vehicle.VIN }}</p>
        <p><strong>Registration Number:</strong> {{ vehicle.registrationNumber }}</p>
      </div>
      <div class="col-lg-6">
        <p><strong>Fuel Type:</strong> {{ vehicle.fuelType }}</p>
        <p><strong>Make: </strong>{{ vehicle.make }}</p>
        <p><strong>Model: </strong>{{ vehicle.model }}</p>
      </div>
    </div>
    <br />
    <div class="row">
      <h4>Trips</h4>
      <table class="table table-bordered table-hover">
        <thead class="thead-dark">
          <th scope="col">Distance (KM)</th>
          <th scope="col">Litres</th>
          <th scope="col">Start Time</th>
          <th scope="col">Start Time Zone</th>
          <th scope="col">End Time</th>
          <th scope="col">End Time Zone</th>
          <th scope="col">Manual Tags</th>
          <th scope="col">Predicted Tags</th>
        </thead>
        <tbody>
          <tr v-for="trip in tripsWithManualAndPredictedTags" :key="trip.id">
            <td>{{ trip.distance }}</td>
            <td>{{ trip.litres }}</td>
            <td>{{ trip.startTime }}</td>
            <td>{{ trip.startTimeZone }}</td>
            <td>{{ trip.endTime }}</td>
            <td>{{ trip.endTimeZone }}</td>
            <td>
              <strong>Personal</strong>
              <div v-if="trip.manualTags.personal">
                <ul v-for="(manualPersonalTag, index) in trip.manualTags.personal" :key="'manualpersonaltags'+ index">
                  <li>{{ manualPersonalTag.name }}</li>
                </ul>
              </div>
              <div v-else>No tags available.</div>
              <strong>Business Client</strong>
              <div v-if="trip.manualTags['business-client']">
                <ul v-for="(manualBusinessClientTag, index) in trip.manualTags['business-client']" :key="'manualbusinessclienttags'+ index">
                  <li>{{ manualBusinessClientTag.name }}</li>
                </ul>
              </div>
              <div v-else>No tags available.</div>
              <strong>Business Purpose</strong>
              <div v-if="trip.manualTags['business-purpose']">
                <ul v-for="(manualBusinessPurposeTag, index) in trip.manualTags['business-purpose']" :key="'manualbusinesspurposetags'+ index">
                  <li>{{ manualBusinessPurposeTag.name }}</li>
                </ul>
              </div>
              <div v-else>No tags available.</div>
            </td>
            <td>
              <strong>Personal</strong>
              <div v-if="trip.predictedTags.personal">
                <ul v-for="(predictedBusinessPurposeTag, index) in trip.predictedTags.personal"  :key="'predictedpersonaltags'+ index">
                  <li>{{ predictedBusinessPurposeTag.name }}</li>
                </ul>
              </div>
              <div v-else>No tags available.</div>
              <strong>Business Client</strong>
              <div v-if="trip.predictedTags['business-client']">
                <ul v-for="(predictedBusinessPurposeTag, index) in trip.predictedTags['business-client']"  :key="'predictedbusinessclienttags'+ index">
                  <li>{{ predictedBusinessPurposeTag.name }}</li>
                </ul>
              </div>
              <div v-else>No tags available.</div>
              <strong>Business Purpose</strong>
              <div v-if="trip.predictedTags['business-purpose']">
                <ul v-for="(predictedBusinessPurposeTag, index) in trip.predictedTags['business-purpose']"  :key="'predictedbusinesspurposetags'+ index">
                  <li>{{ predictedBusinessPurposeTag.name }}</li>
                </ul>
              </div>
              <div v-else>No tags available.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';

export default {
  name: 'VehicleView',
  setup() {},
  data() {
    return {
      vehicle: {},
      tripsWithManualAndPredictedTags: []
    };
  },
  async created() {
    const vehicleId = this.$route.params.id;
    await this.loadVehicle(vehicleId);
    await this.loadTripsWithTags(vehicleId);
  },
  methods: {
    loadVehicle: async function (vehicleId) {
      const result = await apiClient(`vehicles/${vehicleId}`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.vehicle = result.data;
      }
    },
    groupTagsByType: function (tags) {
      return tags.reduce((r, a) => {
        r[a.tagtype] = [...(r[a.tagtype] || []), a];
        return r;
      }, {});
    },
    loadTripsWithTags: async function (vehicleId) {
      const tripsResult = await apiClient(`vehicles/${vehicleId}/trips`, HTTP_METHODS.GET, {}, { redirectOnUnauthorized: true }, {
        'filter[order]': 'endTime DESC'
      });
      const trips = tripsResult.data;
      const tripsWithTagsResult = await apiClient(`vehicles/${vehicleId}/trips-with-tags`, HTTP_METHODS.GET);
      const { vehicleTripsWithTags, vehicleTripsWithPredictedTags } = tripsWithTagsResult.data;

      const result = await Promise.all(
        trips.map(async (trip) => {
          const manualTags = this.groupTagsByType(
            vehicleTripsWithTags.filter((tripWithTags) => tripWithTags.tripid === trip.id)
          );
          const predictedTags = this.groupTagsByType(
            vehicleTripsWithPredictedTags.filter((tripWithTags) => tripWithTags.tripid === trip.id)
          );
          return {
            ...trip,
            manualTags,
            predictedTags
          };
        })
      );
      // do not want reactivity and set array normally
      this.tripsWithManualAndPredictedTags = Object.freeze(result);
    }
  }
};
</script>
